import {
  BankingValueObjectsCardStatusEnum,
  BankingValueObjectsCardTypeEnum,
} from 'generated/resources/graphql'

import { isActive } from './isActive'
import { isCanceled } from './isCanceled'

export const last4digits = (card: {
  last4?: string | null | undefined
  type: BankingValueObjectsCardTypeEnum
  status: BankingValueObjectsCardStatusEnum
}): string => {
  if ((isActive(card) || isCanceled(card)) && card.last4 && card.last4.length === 4) {
    return card.last4
  }

  return '••••'
}
